import PropTypes from "prop-types"
import React from "react"

import Button from "src/components/Button"

const AddLineItemButtons = ({ onAddLabor, onAddParts, disabled = false }) => (
  <div className="flex gap-2">
    <Button variant="secondary" small onClick={onAddLabor} disabled={disabled}>
      + Add Labor
    </Button>
    <Button variant="secondary" small onClick={onAddParts} disabled={disabled}>
      + Add Parts
    </Button>
  </div>
)

AddLineItemButtons.propTypes = {
  onAddLabor: PropTypes.func.isRequired,
  onAddParts: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
}

export default AddLineItemButtons
